// Helper de tracking utilisé par les controllers Stimulus et événements : relaie chaque
// évènement à Umami et à Rybbit (lib/rybbit.js, actif seulement après consentement).
// Vérifie la disponibilité de window.umami avant de tracer.
//
// Usage :
//   import { track } from "lib/umami"
//   track("event_name", { property: "value" })

import { trackRybbit } from "./rybbit.js"

export function track(name, props = {}) {
  trackRybbit(name, props)
  trackUmami(name, props)
}

function trackUmami(name, props) {
  if (typeof window.umami?.track === "function") {
    window.umami.track(name, props)
    return
  }

  // Cold load : le script Umami est chargé en `defer` après le bundle JS, donc
  // window.umami peut ne pas encore exister quand un controller Stimulus trace
  // au boot (ex. page-view qui émet <page>_viewed dans connect()). Les scripts
  // defer ayant fini de s'exécuter avant l'événement `load`, on rejoue l'appel
  // à ce moment-là. Sans effet pour les clics (umami déjà prêt après le boot).
  window.addEventListener(
    "load",
    () => { window.umami?.track?.(name, props) },
    { once: true }
  )
}
